// export const primaryMain = '#7ebcc0';
// export const primaryDark = '#56a7ad';
// export const primaryMedium = "#c5e2e2";
// export const primaryLight = '#e7f3f3';
// export const primaryLightest = '#f8fcfc';

// Sakura-Modern design foundation: navy surfaces with a vivid sakura accent.
export const primaryMain = '#1b2d5b';
export const primaryDark = '#17213d';
export const primaryMedium = '#526994';
export const primaryLight = '#e9edf5';
export const primaryLightest = '#f7f8fc';

// Sakura-Modern --primary.
export const secondaryMain = '#e92063';

// Sakura-Modern pages sit on a white --background.
export const background = '#ffffff';
export const backgroundDark = '#cbd4e3';
export const backgroundLight = '#ffffff';

// export const background = 'white';
// export const backgroundDark = '#d0c9cb';
// export const backgroundLight = '#fefefe';

export const arrivalLineColor = 'red';
export const closureLineColor = 'green';
export const evrCumulativeColor = 'green';
export const evrRollingColor = 'red';
export const openLineColor = 'blue';
export const overlayLineColor = 'black';
export const targetLineColor = '#0000FF33';

export const redCell = 'rgba(255, 0, 0, 0.25)';
export const greenCell = 'rgba(255, 255, 0, 0.5)';
export const yellowCell = 'rgba(0, 255, 0, 0.5)';

export const grey = '#d8dfeb';
export const darkGrey = '#5b6076';
